var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm.$route.query.code == 'notice' ? [_vm._v("공시자료")] : _vm._e()], 2)]), !_vm.$route.params._board && _vm.$route.query.mode !== 'input' ? _c('board-list', {
    attrs: {
      "code": ['notice']
    }
  }) : _vm.$route.query.mode === 'input' ? _c('board-write') : _c('board-view')], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }